import { useCallback } from 'react';
import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { fetchMergedPRsAfterCommit } from '../utils/github';
import { transformMergedPRs } from '../utils/data';

const PRODUCTION_BRANCH = 'production';
const PATHNAME = 'newscorp-ghfb/ncu-gtf';

// TODO: get this from the WP-API (or WPVIP Repo)
const BASE_COMMIT = '1c419babe6b71085a34189fe8646c65e09bb70c5';

export function useGithubApi() {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const fetchResponse = useCallback(
    async (pathname: string = PATHNAME) => {
      const proxyBaseUrl = await discoveryApi.getBaseUrl('proxy');
      const proxyUrl = `${proxyBaseUrl}/github-api`;

      const { token } = await identityApi.getCredentials();

      const mergedPRs = await fetchMergedPRsAfterCommit({
        proxyUrl,
        token,
        pathname,
        baseBranch: PRODUCTION_BRANCH,
        sinceCommit: BASE_COMMIT,
      });

      return {
        changes: transformMergedPRs(mergedPRs),
      };
    },
    [discoveryApi, identityApi],
  );

  return fetchResponse;
}
